import Home from './HomeUserSupplier';

export default Home;
